import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { toast } from 'react-toastify';
import { Alert, Badge, Modal, ModalBody, ModalHeader } from 'reactstrap';

import style from '../../styles/layout.module.css';
import request from '../../utils/useAxios';


const SortMenuModel = ({ openModal = false, setOpenModel = () => {} }) => {
  const [menus, setMenus] = useState([]);
  const sortMenus = useRef([]);

  const getAllMenuList = useCallback(async () => {
    const res = await request({
      data: {
        order: '',
        order_by: '',
        page: 0,
        page_size: 0,
        type: 0,
      },
      method: 'post',
      url: '/Backend/Cafe_MealCoffeeMenu/list',
    });
    if (res.code === 200) {
      return (res.result.datas || []).map((data, index) => {
        return {
          index: index + 1,
          ...data,
        };
      });
    }
    return [];
  }, []);

  const sortMenuList = useCallback(async menus => {
    const res = await request({
      data: menus.map((menu, index) => {
        return {
          id: menu.id,
          sort: index,
        };
      }),
      method: 'post',
      url: '/Backend/Cafe_MealCoffeeMenu/sort',
    });
    if (res.code === 200) {
      toast.success('修改完成');
      return res;
    } else {
      toast.success('修改失敗');
      throw res;
    }
  }, []);

  const handleOnDragEnd = result => {
    const { source, destination } = result;
    if (!destination) {
      return;
    }
    const [remove] = sortMenus.current.splice(source.index, 1);
    sortMenus.current.splice(destination.index, 0, remove);
    setMenus(sortMenus.current);
  };

  useEffect(() => {
    if (openModal) {
      getAllMenuList().then(menus => {
        setMenus(menus);
        sortMenus.current = [...menus];
      });
    }
  }, [openModal, getAllMenuList, setMenus]);

  return (
    <div className={style.modal}>
      <Modal
        centered
        size="lg"
        isOpen={openModal}
        toggle={() => {
          sortMenuList(menus).then(() => {
            setOpenModel(false);
          });
        }}
        backdrop="static"
      >
        <ModalHeader
          className={style.modal_head}
          toggle={() => {
            sortMenuList(menus).then(() => {
              setOpenModel(false);
            });
          }}
        >
          咖啡選單排序
        </ModalHeader>
        <ModalBody>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="brands">
              {provided => (
                <ul
                  className="drag_list"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {menus.map((menu, index) => (
                    <Draggable
                      key={menu.id}
                      draggableId={`${menu.id}`}
                      index={index}
                    >
                      {provided => (
                        <li
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                        >
                          <Alert color="warning" className="d-flex p-0 w-100">
                            <Badge className="d-flex align-items-center">
                              {menu.index}
                            </Badge>
                            <div className="p-3">{menu.name}</div>
                          </Alert>
                        </li>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          </DragDropContext>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default memo(SortMenuModel);
